import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';

import Home from './pages/home';
import Mari from './pages/projects/mari';

import reportWebVitals from './functions/start/reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mari" element={<Mari />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();